import { useQuery } from '@tanstack/react-query';
import { APIPatient } from 'lib/api/firebase/apis/api-patient';
import { queryKeyFactory } from 'lib/utils/queryKeyFactory';

export function useGetPatientImpactProfile(patientId: string) {
  return useQuery({
    queryKey: queryKeyFactory.patient.impactProfile(patientId),
    queryFn: () => APIPatient.getPatientImpactProfile({ patientId })
  });
}
